import { FormItemsGroup, type InputProps, Spacing } from '@billy/design-system'
import type { ReactElement } from 'react'

import { PaymentMethodsTextField, type PaymentMethodsTextFieldProps } from '../PaymentMethodsTextField'

type BankTransferFieldKey = 'bank' | 'iban' | 'swift'

type BankTransferFieldProps = Pick<PaymentMethodsTextFieldProps, 'label' | 'onValueChange'>

interface BankTransferFieldsProps {
  fields: Record<BankTransferFieldKey, BankTransferFieldProps>
  size?: InputProps['size']
}

export const BankTransferFields = ({ fields, size }: BankTransferFieldsProps): ReactElement => (
  <>
    <PaymentMethodsTextField {...fields.iban} fieldKey="iban" size={size} />
    <FormItemsGroup itemsInRow={2} spacing={Spacing.S16}>
      <PaymentMethodsTextField {...fields.swift} fieldKey="swift" size={size} />
      <PaymentMethodsTextField {...fields.bank} fieldKey="bank" size={size} />
    </FormItemsGroup>
  </>
)
